export default __webpack_public_path__ + "static/media/saint_aubin5.2a0c6512.jpg";